import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'sonner';
import { getApi } from '../../api/call.api';
import { urlApi } from '../../api/url.api';
import TableComponent from '../../components/DataTable/TableComponent';
import Layout from '../../layout/Layout';
import Issues from './Issues';

const Setting = () => {

    const [activePage, setActivePage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const [tableData, setTableData] = useState({
        data: [],
        totalCount: 0
    });

    function handlePageChange(page) {
        setActivePage(page);
    }

    function handlePerRowsChange(newPerPage, page) {
        setActivePage(page);
        setPerPage(newPerPage)
    }

    const getSettingData = async () => {
        const resp = await getApi(`${urlApi.getSettings}?page=${activePage}&limit=${perPage}`);
        if (resp.responseCode === 200) {
            setTableData({
                data: resp.data?.items,
                totalCount: resp.data?.count
            })
        } else {
            toast.error(resp.message);
        }
    }

    useEffect(() => {
        getSettingData()
    }, [activePage, perPage]);

    const columns = [
        { name: "Sl. No", center: "true", width: "60px", selector: (row) => row?._id, cell: (row, index) => (activePage - 1) * perPage + (index + 1) },
        {
            name: "Name", center: "true", selector: (row) => row?.name, cell: (row) => (
                <div className='text-center'>
                    <p className='fw-bold'>{row?.name}</p>
                </div>
            ),
        }, {
            name: "Version", center: "true", selector: (row) => row?.versionCode, cell: (row) => (<span> {row?.versionCode ?? "--"}</span>),
        }, {
            name: "Update", center: "true", selector: (row) => row?.createdAt, cell: (row) =>
                <Link to={'/update-setting/' + row?._id} className='bg-purple-700 !px-5 !py-1.5 rounded-full text-sm text-white' >Update</Link>
        },]

    return (
        <Layout>
            <div className='flex items-center mb-3 justify-between'>
                <h1 className='text-xl font-bold text-gray-600'>Settings</h1>
            </div>

            <TableComponent
                columns={columns}
                data={tableData.data}
                totalRows={tableData.totalCount}
                isPagination={true}
                handlePageChange={(e) => handlePageChange(e)}
                handlePerRowsChange={(newPerPage, page) => handlePerRowsChange(newPerPage, page)} />

            <hr className='my-6' />

            <Issues />

        </Layout>
    )
}

export default Setting